// extracted by mini-css-extract-plugin
export default {"heroSectionStack":"HeroSectionPage_heroSectionStack__nff77"};